export default __webpack_public_path__ + "static/media/Minimizar.b3b3ad7d.svg";